import React from "react";
import Marquee from "react-fast-marquee";
import CurrencyIcon from "../ui/CurrencyIcon";
import { formatCurrencyAmount, isAmountHidden, resolveDisplayCurrency } from "../../common/currencies";

const MarqueeBar = ({ data = [] }) => {
  // Demo-currency wins would leak the amount, so they never reach the ticker.
  const items = data.filter((item) => !isAmountHidden(item?.currencyCode));
  if (!items.length) return null;

  return (
    <div className="rounded-app  text-xs sm:text-sm">
      <Marquee speed={30} pauseOnHover={true} className="bg-transparent">

        {items.map((item, index) => {
          const displayCurrency = resolveDisplayCurrency(item?.currencyCode);
          const amountValue = formatCurrencyAmount(item?.amount, displayCurrency);

          return (
            <span key={index} className="divider whitespace-nowrap">
              <span className="font-bold">{item?.username || "John"}</span>
              <span className="font-normal"> just won </span>
              <span className="font-extrabold text-greenShade1">
                <CurrencyIcon
                  code={displayCurrency}
                  className="h-3.5 w-3.5 align-middle mr-0.5"
                />
                {amountValue}
              </span>
              <span className="font-normal"> in </span>
              <span className="font-bold text-white">{item?.displayName || item?.gameName}</span>
              <span className="mx-2 text-gray-400" aria-hidden="true">&bull;</span>
            </span>
          );
        })}
      </Marquee>
    </div>
  );
};

export default MarqueeBar;
